export default function buildMakeFlowDeviceKFactor({ validate, validators }) {
  return function makeFlowDeviceKFactor({
    id,
    flowDeviceId,
    kFactor,
    coefficient,
    minPsi,
    maxPsi,
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,
  }) {
    const schema = {
      id: {
        prettyName: 'ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      flowDeviceId: {
        prettyName: 'Flow Device ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      kFactor: {
        prettyName: 'K-Factor',
        validators: [validators.isNumber()],
      },
      coefficient: {
        prettyName: 'Coefficient',
        validators: [validators.isNumber()],
      },
      minPsi: {
        prettyName: 'Minimum PSI',
        validators: [validators.isNumber()],
      },
      maxPsi: {
        prettyName: 'Maximum PSI',
        validators: [validators.isNumber()],
      },
    };

    return Object.freeze({
      get id() { return id },
      get flowDeviceId() { return flowDeviceId },
      get kFactor() { return kFactor },
      get coefficient() { return coefficient },
      get minPsi() { return minPsi },
      get maxPsi() { return maxPsi },
      get createdBy() { return createdBy },
      get createdDate() { return createdDate ? new Date(createdDate) : null },
      get modifiedBy() { return modifiedBy },
      get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
      get deletedBy() { return deletedBy },
      get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
      validate() {
        const errors = validate(this, schema);
        if (errors.length > 0) {
          const message = errors.map(e => e.name + ': ' + e.message).join('\n');
          const validationError = new Error(message);
          validationError.name = 'ValidationError';
          throw validationError;
        }
      }
    });
  }
}